(function () {
    function controller() {
        var vm = this;
        vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
        vm.hasSobEnhancement = abp.setting.getBoolean('Hms.Feature.SobEnhancement');
    }

    angular.module('app').component('hostDoraemonCommonBalancePoolTableComponent', {
        templateUrl: require('/App/host/views/doraemon/common/balancePoolTable/balancePoolTable.component.html'),
        controller: controller,
        controllerAs: 'vm',
        bindings: {
            benefits: '<',
            hospitalizationBenefits: '<',
            isHospitalization: '<'
        }
    });
})();
